export const playerTemplate = `
<main id="player" class="player">
      <section class="main-video" aria-label="Video player">
        <video id="video" playsinline muted preload="metadata"></video>
        <div class="topline">
          <span>COUNTER-STRIKE 2</span
          ><span id="clipLabel" class="sample"></span>
        </div>
        <button
          id="corner"
          class="corner sponsor-action"
          aria-label="Sponsor offer"
        ></button>
        <button id="bigPlay" class="big-play" aria-label="Play clip">▶</button>
        <div id="offer" class="offer" hidden>
          <div class="brand-mark"></div>
          <div class="offer-copy">
            <strong class="brand-line"></strong
            ><span class="brand-detail"></span>
          </div>
          <button class="cta sponsor-action brand-cta"></button
          ><button id="dismiss" class="dismiss" aria-label="Dismiss offer">
            ×
          </button>
        </div>
        <section
          id="endcard"
          class="endcard"
          aria-label="Sponsored endcard"
          hidden
        >
          <a class="end-art" target="_blank" rel="noopener noreferrer" hidden>
            <span class="card-header"
              ><span class="brand-title"></span
              ><span aria-hidden="true">↗</span></span
            >
            <span class="creative-fallback">Creative unavailable</span>
          </a>
          <div class="end-bottom">
            <div class="end-copy">
              <span class="takeover-label">Sponsored</span>
              <h1 class="brand-title"></h1>
            </div>
            <div class="end-actions">
              <button class="cta sponsor-action brand-cta"></button>
              <button id="next" aria-label="Next clip">
                <span class="countdown-ring"
                  ><svg viewBox="0 0 44 44" aria-hidden="true">
                    <circle class="ring-track" cx="22" cy="22" r="18" />
                    <circle id="countdownRing" cx="22" cy="22" r="18" /></svg
                  ><span id="countdown">5</span></span
                >
                <span class="next-label">Next clip</span>
              </button>
              <button id="replay">↺ Replay</button>
            </div>
          </div>
        </section>
        <section id="upNext" class="up-next" aria-label="Up next" hidden>
          <div class="up-next-content">
            <p id="upNextLabel" class="up-next-label">UP NEXT</p>
            <div class="up-next-preview">
              <div id="upNextArt" class="up-next-art" aria-hidden="true"></div>
              <div class="up-next-copy">
                <h2 id="upNextTitle"></h2>
                <p id="upNextMeta"></p>
              </div>
            </div>
            <div class="up-next-actions">
              <button id="playNext" class="play-next">▶ Play now</button>
              <button id="replayClip">↺ Replay</button>
              <span id="upNextCountdown" role="status"></span>
            </div>
          </div>
          <div class="up-next-progress" aria-hidden="true"><i id="upNextProgress"></i></div>
        </section>
        <div class="controls">
          <button id="play" aria-label="Play">▶</button
          ><button id="mute" aria-label="Unmute"></button
          ><label class="seek-wrap"
            ><span class="sr-only">Seek video</span
            ><input
              id="seek"
              type="range"
              min="0"
              max="100"
              step="0.1"
              value="0" /><i id="apexMarker" title="Sample apex"></i></label
          ><span id="time">0:00</span
          ><button id="full" aria-label="Fullscreen">⛶</button
          >
        </div>
        <div id="mediaError" class="media-error">Loading live playlist…</div>
      </section>
      <aside class="playlist">
        <div class="list-heading" role="group" aria-label="Filter highlights">
          <span class="show-label">SHOW</span>
          <button data-filter="trending" aria-pressed="true">
            <svg
              viewBox="0 0 16 16"
              width="12"
              height="12"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M2 11.5 6 7.5l2.5 2.5L13 5M9.5 5h3.5v3.5" />
            </svg>
            Trending <strong>0</strong>
          </button>
          <button data-filter="aces" aria-pressed="false">
            <svg
              viewBox="0 0 16 16"
              width="12"
              height="12"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path
                d="M8 1.5c1 2 3 3 3 6a3 3 0 0 1-6 0c0-1.2.5-2 1.2-2.6C6.6 5 6.4 4 8 1.5Z"
              />
              <path d="M5 9.5a3 3 0 0 0 6 0" />
            </svg>
            Aces <strong>0</strong>
          </button>
          <button data-filter="fourk" aria-pressed="false">
            <svg
              viewBox="0 0 16 16"
              width="12"
              height="12"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <circle cx="8" cy="8" r="5" />
              <path d="M8 1v3M8 12v3M1 8h3M12 8h3" />
            </svg>
            4K <strong>0</strong>
          </button>
        </div>
        <span id="playlistCount" class="sr-only" role="status"
          >LIVE PLAYLIST</span
        >
        <div
          id="clipList"
          role="region"
          aria-label="Highlights"
          tabindex="0"
        ></div>
        <p id="emptyPlaylist" class="empty-playlist" hidden>
          No highlights in this category.
        </p>
        <button
          id="scrollPlaylist"
          class="scroll-playlist"
          aria-label="Scroll to more highlights"
          hidden
        >
          <svg
            viewBox="0 0 16 16"
            width="12"
            height="12"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="m4 4 4 4 4-4M4 8l4 4 4-4" />
          </svg>
        </button>
        <button id="nativeAd" class="native-ad sponsor-action" hidden>
          <span class="brand-mark"></span
          ><span class="ad-copy"
            ><b class="brand-line"></b
            ><span class="native-meta"
              ><span class="sponsor-flag">Sponsored</span
              ><span class="brand-detail"></span></span></span
          ><span class="cta brand-cta"></span>
        </button>
        <button id="railAd" class="rail-ad sponsor-action" hidden>
          <span class="brand-mark"></span
          ><span class="ad-copy"
            ><b class="brand-line"></b><span class="brand-detail"></span></span
          ><span class="cta brand-cta"></span>
        </button>
      </aside>
      <button id="playlistToggle" class="playlist-toggle" aria-expanded="false">
        More highlights <span>Open playlist ＋</span>
      </button>
    </main>
`;
